<template>
  <div class="forgotPassword">
    <div class="forgotPassword__panelWrapper">
      <div
        class="forgotPassword__row flex flex-col gap-4 text-secondary-base sm:mb-0 mb-3 items-center"
      >
        <div class="forgotPassword__row !justify-center">
          <p class="text-[32px] leading-[40px] font-extrabold">
            Recovery link sent!
          </p>
        </div>
        <div class="forgotPassword__row !justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M17 21.25H7C6.59 21.25 6.25 20.91 6.25 20.5C6.25 20.09 6.59 19.75 7 19.75H17C19.86 19.75 21.25 18.36 21.25 15.5V8.5C21.25 5.64 19.86 4.25 17 4.25H7C4.14 4.25 2.75 5.64 2.75 8.5C2.75 8.91 2.41 9.25 2 9.25C1.59 9.25 1.25 8.91 1.25 8.5C1.25 4.85 3.35 2.75 7 2.75H17C20.65 2.75 22.75 4.85 22.75 8.5V15.5C22.75 19.15 20.65 21.25 17 21.25Z"
              fill="#292D32"
            />
            <path
              d="M11.9998 12.87C11.1598 12.87 10.3098 12.61 9.65978 12.08L6.52978 9.57997C6.20978 9.31997 6.14978 8.84997 6.40978 8.52997C6.66978 8.20997 7.13977 8.14997 7.45977 8.40997L10.5898 10.91C11.3498 11.52 12.6398 11.52 13.3998 10.91L16.5298 8.40997C16.8498 8.14997 17.3298 8.19997 17.5798 8.52997C17.8398 8.84997 17.7898 9.32997 17.4598 9.57997L14.3298 12.08C13.6898 12.61 12.8398 12.87 11.9998 12.87Z"
              fill="#292D32"
            />
            <path
              d="M8 17.25H2C1.59 17.25 1.25 16.91 1.25 16.5C1.25 16.09 1.59 15.75 2 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25Z"
              fill="#292D32"
            />
            <path
              d="M5 13.25H2C1.59 13.25 1.25 12.91 1.25 12.5C1.25 12.09 1.59 11.75 2 11.75H5C5.41 11.75 5.75 12.09 5.75 12.5C5.75 12.91 5.41 13.25 5 13.25Z"
              fill="#292D32"
            />
          </svg>
        </div>
        <div class="forgotPassword__row flex items-center flex-col gap-6">
          <p class="text-[25px]">Now, check your email.</p>
          <p
            class="text-sm leading-[21px] font-medium text-greyscale-700 text-center"
          >
            If an account is associated with your provided email address, you
            will receive a password reset email shortly.
          </p>
        </div>
      </div>
      <div class="forgotPassword__row flex-col gap-[10px]">
        <div class="forgotPassword__column">
          <Button @click="goToSignIn" class="secondary large w-full sm:hidden"
            >Sign In</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
export default {
  name: "SendedRequest",
  components: { Button },
  methods: {
    goToSignIn() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style scoped>
@import "index.module.css";
</style>
